import { useLang } from "@/context/LanguageContext";
import { AfricaMap } from "@/components/AfricaMap";
import { Reveal } from "@/components/Reveal";

export const AfricaBand = () => {
  const { t } = useLang();
  if (!t) return null;
  const a = t.africa;

  return (
    <section className="bg-white py-20 md:py-32" data-testid="africa-section">
      <div className="max-w-7xl mx-auto px-4 md:px-8 grid gap-12 md:grid-cols-2 md:gap-16 items-center">
        <Reveal>
          <span className="text-xs uppercase tracking-[0.25em] text-rouge font-medium">{a.eyebrow}</span>
          <h2 className="fluid-h2 mt-5 text-noir">{a.title}</h2>
          <p className="mt-5 text-gris leading-relaxed">{a.text}</p>

          <div className="mt-9 grid grid-cols-3 gap-4" data-testid="africa-stats">
            {a.stats.map((st, i) => (
              <Reveal
                key={st.label || i}
                delay={i * 90}
                className="rounded-xl border border-ligne bg-creme/50 p-5 text-center hover:border-or hover:shadow-lg hover:shadow-noir/5 hover:-translate-y-1 transition-[transform,border-color,box-shadow] duration-300"
              >
                <div className="font-serif text-3xl text-rouge">{st.value}</div>
                <div className="mt-1 text-xs text-gris leading-snug">{st.label}</div>
              </Reveal>
            ))}
          </div>
        </Reveal>

        <Reveal
          delay={120}
          className="relative aspect-square rounded-2xl bg-noir overflow-hidden grain grid place-items-center shadow-2xl shadow-noir/20"
        >
          <div
            className="absolute inset-0 opacity-[0.18]"
            style={{ backgroundImage: "radial-gradient(circle at 30% 30%, #B68A35 0, transparent 40%), radial-gradient(circle at 70% 70%, #E0301E 0, transparent 45%)" }}
          />
          <AfricaMap className="relative h-[86%] w-auto" />
        </Reveal>
      </div>
    </section>
  );
};

export default AfricaBand;
